export const NotFoundPage = (): JSX.Element => (
  <div>
      page not found
  </div>
);
